import { render, staticRenderFns } from "./CustomHR.vue?vue&type=template&id=4c0c6b47&scoped=true"
import script from "./CustomHR.vue?vue&type=script&lang=js"
export * from "./CustomHR.vue?vue&type=script&lang=js"
import style0 from "./CustomHR.vue?vue&type=style&index=0&id=4c0c6b47&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c6b47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0c6b47')) {
      api.createRecord('4c0c6b47', component.options)
    } else {
      api.reload('4c0c6b47', component.options)
    }
    module.hot.accept("./CustomHR.vue?vue&type=template&id=4c0c6b47&scoped=true", function () {
      api.rerender('4c0c6b47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/page/CustomHR.vue"
export default component.exports